import * as React from 'react';

import IframePopup from '@/components/display/popup/iframe-popup';

type Props = {
    title: string | JSX.Element;
    url: string;
    isOpen: boolean;
    onClose: () => void;
    width?: number;
    height?: number;
};

export type DialogData = {
    title: string;
    project: string;
    iframeUrl: string;
    isOpen: boolean;
};

const GrantsPopupDialog = (props: Props) => {
    return <IframePopup {...props} />;
};

export default GrantsPopupDialog;
